export const fixFloat = (num) => {
    return parseFloat(num.toFixed(10));
};
//# sourceMappingURL=fix-float.js.map